/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import axios from "axios";
import { MenuOpenOutlined } from "@material-ui/icons";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const { REACT_APP_MENU_URL } = process.env;
  const [menu, setMenu] = useState([]);

  const getMenu = async () => {
    try {
      const data = {
        role: ["99", "8"],
        route: "dashboard",
      };
      const response = await axios.post(`${REACT_APP_MENU_URL}`, data);
      return response;
    } catch (err) {
      if (err.response) {
        console.log(err.response);
      } else {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    // getMenu()
    // .then(({data: {data}})=> {
    //   setMenu(data.menu);
    //   // console.log(data.menu);
    //   Object.values(data.menu).map((data)=>{
    //     console.log(data[1]);
    //   })
    // })
  }, []);

  // const showMenu = () => {
  //    menu.map((data, index)=>{
  //       console.log(index);
  //   })
  // }

  return (
    <>
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/* {showMenu()} */}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/kontraktor", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/kontraktor">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Perekaman Data Kontraktor Utama</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/bkpjkp", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/bkpjkp">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Perekaman Data BKP dan JKP</span>
          </NavLink>
        </li>
        {/* <li
          className={`menu-item ${getMenuItemActive("/meterai", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/meterai">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Penyedia</span>
          </NavLink>
        </li> */}

        {/* <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/monitoring",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/monitoring">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Devices/Display1.svg")}
              />
            </span>
            <span className="menu-text">Monitoring</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item  menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">Monitoring</span>
                </span>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/monitoring/meterai"
                )}`}
                aria-haspopup="true"
              >
                <NavLink
                  className="menu-link menu-toggle"
                  to="/monitoring/meterai"
                >
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Meterai</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/monitoring/monitoring-penyedia"
                )}`}
                aria-haspopup="true"
              >
                <NavLink
                  className="menu-link menu-toggle"
                  to="/monitoring/monitoring-penyedia"
                >
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Penyedia</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/penyedia",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/penyedia">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Layout/Layout-top-panel-4.svg")}
              />
            </span>
            <span className="menu-text">Penyedia</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item  menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">Penyedia</span>
                </span>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/penyedia/aplikasi"
                )}`}
                aria-haspopup="true"
              >
                <NavLink
                  className="menu-link menu-toggle"
                  to="/penyedia/aplikasi"
                >
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Aplikasi</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/penyedia/printer"
                )}`}
                aria-haspopup="true"
              >
                <NavLink
                  className="menu-link menu-toggle"
                  to="/penyedia/printer"
                >
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Printer</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li> */}
      </ul>
    </>
  );
}
